var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGreenCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 0.428711C17.3136 0.428711 0.0942383 17.8238 0.0942383 39.0844C0.0942383 60.3451 17.4893 77.7401 38.75 77.7401C60.1863 77.7401 77.4057 60.3451 77.4057 39.0844C77.4057 17.8238 60.1863 0.428711 38.75 0.428711ZM62.1191 30.6505L38.0471 56.3038C36.9929 57.358 35.5872 57.8852 34.1816 57.8852C34.0059 57.8852 33.8301 57.8852 33.6544 57.8852C32.4245 57.7095 31.1945 57.1823 30.4917 56.3038L17.1379 41.72C15.2051 39.6116 15.3808 36.2731 17.4893 34.3403C19.5978 32.4075 22.9363 32.5832 24.869 34.6917L34.3573 45.0585L54.5637 23.4464C56.4964 21.3379 59.8349 21.1622 61.9434 23.2707C64.0519 25.2035 64.0519 28.542 62.1191 30.6505Z",
    fill: "#00D44E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenCheck);
export default __webpack_public_path__ + "static/media/icon_green_check.48ec30f0d86a444dd8878f3218501f54.svg";
export { ForwardRef as ReactComponent };